import {
  fromWebFile,
  type PickImageOptions,
  type UploadableImageAsset,
} from './image-upload';

/** Web twin of pick-image: a hidden `<input type="file">`. */
export type { PickImageOptions, UploadableImageAsset };

export async function pickImageForUpload(
  _options: PickImageOptions = {},
): Promise<UploadableImageAsset | null> {
  if (typeof document === 'undefined') return null;

  const file = await new Promise<File | null>((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/png,image/jpeg,image/webp';
    input.style.display = 'none';
    // `cancel` fires when the OS dialog is dismissed without a pick; without it
    // the input node would leak into the DOM on every cancelled pick.
    input.oncancel = () => {
      input.remove();
      resolve(null);
    };
    input.onchange = () => {
      const picked = input.files?.[0] ?? null;
      input.remove();
      resolve(picked);
    };
    document.body.appendChild(input);
    input.click();
  });

  if (!file) return null;

  // Throws ImageUploadError for unsupported types / oversized files, which the
  // caller surfaces as a toast — same contract as the native twin.
  return fromWebFile(file);
}
